<template>
  <div v-click-outside="close" class="auto-complete-main">
    <fdd-input
      ref="reference"
      v-model="mode"
      :searchable="searchable"
      :clearable="clearable"
      :placeholder="placeholder"
      :input-class="inputClass"
      :max-length="maxLength"
      :disabled="disabled"
      @focus="handleFocus"
      @blur="handleBlur"
      @search="handleSearch"
    />
    <transition name="fade" @after-leave="destroyPopper">
      <div v-show="visible" ref="popper" v-transfer-dom class="auto-complete-popper" :style="{ width }">
        <div v-if="loading" v-loading="loading" class="auto-complete-loading"></div>
        <p
          v-for="(item, index) in suggestions"
          v-else-if="suggestions.length"
          :key="index"
          class="auto-complete-suggestion"
          @click="handleChoose(item)"
        >
          <slot :item="item">{{ item[valueKey] }}</slot>
        </p>

        <div v-else-if="showTips" class="auto-complete-no-data">
          {{ tipsText }}
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  import clickOutside from '../../utils/clickoutside'
  import popper from '@/packages/tooltip/mixins/popper'
  import transferDom from '@/packages/utils/transfer-dom'

  const LOADING_TIME = 200

  export default {
    name: 'FddAutocomplete',
    directives: { clickOutside, transferDom },
    mixins: [popper],
    props: {
      valueKey: {
        type: String,
        default: 'value'
      },
      placeholder: {
        type: String,
        default: '请输入'
      },
      value: {
        type: String,
        required: true
      },
      inputClass: {
        type: [String, Object, Array],
        default: ''
      },
      placement: {
        type: String,
        default: 'bottom-start'
      },
      maxLength: Number,
      disabled: Boolean,
      modifiers: {
        type: Array,
        default: () => [
          {
            name: 'offset',
            options: {
              offset: [0, 8]
            }
          },
          {
            name: 'arrow',
            options: {
              padding: 8
            }
          }
        ]
      },
      query: {
        type: Function,
        default: null
      },
      searchable: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      tipsText: {
        type: String,
        default: '无数据'
      },
      showTips: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        visible: false,
        width: 0,
        loading: false,
        suggestions: [],
        noData: false
      }
    },
    computed: {
      mode: {
        set(value) {
          this.$emit('input', value)
        },
        get() {
          return this.value
        }
      }
    },
    watch: {
      visible(value) {
        this.$emit('visible-change', value)
        if (value) {
          this.updatePopper()
          const el = this.referenceElm
          if (el) {
            this.width = el.getBoundingClientRect().width + 'px'
          }
        }
      }
    },
    mounted() {
      this.referenceElm = this.$refs.reference.$el
    },
    methods: {
      handleFocus(e) {
        this.$emit('focus', e)
      },
      handleBlur(e) {
        this.$emit('blur', e)
      },
      handleChoose(item) {
        this.$emit('input', item[this.valueKey])
        this.$emit('select', item)
        this.close()
      },
      close() {
        this.visible = false
      },
      async handleQuery() {
        this.visible = true
        const { query } = this
        if (typeof query !== 'function') throw new Error('query must be a function')

        this.loading = true
        try {
          const { list } = await query(this)
          this.suggestions = list || []
          this.setShowTips()
        } finally {
          setTimeout(() => (this.loading = false), LOADING_TIME)
        }
      },
      handleSearch() {
        this.$emit('search', this.handleQuery, this.model)
      },
      setShowTips() {
        if (!this.suggestions.length && !this.showTips) this.visible = false
      }
    }
  }
</script>
<style scoped lang="less">
  @borderColor: rgb(255, 255, 255);
  @posPx: -5px;

  .auto-complete {
    &-popper {
      z-index: 101;
      overflow-y: auto;
      max-height: 300px;
      background: @borderColor;
      box-shadow: 0 4px 6px 0 rgba(94, 95, 97, 0.15);
      border-radius: 4px;
      border: 1px solid rgb(222, 224, 230);
    }

    &-suggestion {
      line-height: 1.3;
      padding: 12px 16px;
      cursor: pointer;

      &:hover {
        background: #ecf4fe;
        color: #276ef9;
      }
    }

    &-loading {
      min-height: 200px;
    }
    &-no-data {
      text-align: center;
      padding: 30px 0;
      color: #999;
      font-size: 12px;
    }
  }
</style>
